import { ReactElement } from 'react'
import About from '../Pages/About/About'
import Checkout from '../Pages/Checkout/Checkout'
import ContactUs from '../Pages/Contact/Contact'
import ForgetPassword from '../Pages/ForgetPassword/ForgetPassword'
import Home from '../Pages/Home/Home'
import PastBookings, { getBookings } from '../Pages/PastBookings/PastBookings'
import PaymentHandler from '../Pages/PaymentHandler/PaymentHandler'
import ResetPassword from '../Pages/ResetPassword/ResetPassword'
import SamplePage from '../Pages/SamplePage/SamplePage'
import Services from '../Pages/Services/Services'
import PrivateJetChauffeurServiceLondon from '../Pages/Services/PrivateJetChauffeurServiceLondon/PrivateJetChauffeurServiceLondon'
import AirportJetChauffeurServiceLondon from '../Pages/Services/AirportJetChauffeurServiceLondon/AirportJetChauffeurServiceLondon'
import CorporateJetChauffeurServiceLondon from '../Pages/Services/CorporateJetChauffeurServiceLondon/CorporateJetChauffeurServiceLondon'
import CruisePortChauffeurTransfersLondon from '../Pages/Services/CruisePortChauffeurTransfersLondon/CruisePortChauffeurTransfersLondon'
import LondonDayTripChauffeur from '../Pages/Services/LondonDayTripChauffeur/LondonDayTripChauffeur'
import FilmandTVProductionChauffeurServicesLondon from '../Pages/Services/FilmandTVProductionChauffeurServicesLondon/FilmandTVProductionChauffeurServicesLondon'
import List from '../Pages/list/list'
import ProtectedRoute from '../Components/ProtectedRoute/ProtectedRoute'
import { UserModel } from '../models/user.model'
import TermsAndConditions from '../Pages/TermsAndConditions/TermsAndConditions'
import PrivacyAndPolicy from '../Pages/PrivacyAndPolicy/PrivacyAndPolicy'
import Blog from '../Pages/Blog/Blog'
import BlogPost1 from '../Pages/Blog/BlogPost1/BlogPost1'
import BlogPost2 from '../Pages/Blog/BlogPost2/BlogPost2'

interface RouteConfig {
  path: string
  element: ReactElement
  requiresAuth?: boolean
  loader?: () => any
}

export const routeConfig: RouteConfig[] = [
  {
    path: '',
    element: <Home />,
  },
  {
    path: 'list',
    element: <List />,
  },

  {
    path: 'blog',
    element: <Blog/>,
  },
  {
    path: 'blog/chauffeur-rides-ltd-redefining-luxury-chauffeur-service-london',
    element: <BlogPost1 />,
  },
  {
    path: 'blog/premium-chauffeur-rides-london-travel-comfort-style',
    element: <BlogPost2 />,
  },

  {
    path: 'checkout',
    element: <Checkout />,
    requiresAuth: true,
  },
  {
    path: 'about',
    element: <About />,
  },
  {
    path: 'services',
    element: <Services />,
  },
  {
    path: 'services/PrivateJetChauffeurServiceLondon',
    element: <PrivateJetChauffeurServiceLondon />,
  },
  {
    path: 'services/AirportJetChauffeurServiceLondon',
    element: <AirportJetChauffeurServiceLondon />,
  },
  {
    path: 'services/CorporateJetChauffeurServiceLondon',
    element: <CorporateJetChauffeurServiceLondon />,
  },
  {
    path: 'services/CruisePortChauffeurTransfersLondon',
    element: <CruisePortChauffeurTransfersLondon />,
  },
  {
    path: 'services/LondonDayTripChauffeur',
    element: <LondonDayTripChauffeur />,
  },
  {
    path: 'services/FilmandTVProductionChauffeurServicesLondon',
    element: <FilmandTVProductionChauffeurServicesLondon />,
  },
  {
    path: 'contact',
    element: <ContactUs />,
  },
  {
    path: 'forget-password',
    element: <ForgetPassword />,
  },
  {
    path: 'reset-password',
    element: <ResetPassword />,
  },
  {
    path: 'payment',
    element: <PaymentHandler />,
    requiresAuth: true,
  },
  {
    path: 'bookings',
    element: <PastBookings />,
    requiresAuth: true,
  },
  {
    path: 'sample-page',
    element: <SamplePage />,
  },
  {
    path: 'terms-and-conditions',
    element: <TermsAndConditions />,
  },


  {
    path: 'privacy-policy',
    element: <PrivacyAndPolicy />,
   },
]

export const processRouteConfig = (
  config: RouteConfig[],
  profile: UserModel | null,
  accessToken: string | null,
) => {
  return config.map(route => {
    const processedRoute: any = {
      path: route.path,
      element: route.requiresAuth ? (
        <ProtectedRoute>{route.element}</ProtectedRoute>
      ) : (
        route.element
      ),
    }

    if (route.path === 'bookings' && route.requiresAuth) {
      processedRoute.loader = () => {
        if (!profile?.id || !accessToken) {
          return []
        }
        return getBookings(profile?.id, accessToken)
      }
    }

    return processedRoute
  })
}
